export const PROMO_CODES = [
    "ANXETTLMMMX4",
    "ENJ7JK9L4HT6",
    "J3477YJT3PWH",
    "M99THRPNYFEK",
    "4JX7JFEE3J6R",
    "69XMMYXP7X3T",
    "TMY3MYTFHW47",
    "RJAJTM4KXKT9",
    "TYRH4APJJL9K",
    "YXHYX73MKF9T",
    "6RJ33NKTJWKN",
    "4TAH679MEMHR",
    "A9A9WJJHMFLX",
    "PA9WMKR4J4WY",
    "7EWWYNMYMPFF",
    "6N69MMPMHHF7",
    "KR4HX6LWX7K4",
    "4APHL3NAYAXH",
    "AMFK3MMLMTHW",
    "H9R3L4HNAPYP",
    "LJXTNFLK9FT9",
    "MWFFLRTHHPT4",
    "YFFLNJLJTYNA",
    "RAL4TLHW3MA9",
    "E3XLLHMRMAJN",
    "XTW3HF7R3MER",
    "RNXP9Y7KXFHM",
    "FTTK3JLJYHM6",
    "HM3ETPRFY4TF",
    "WJ6M4KMXH6PL",
    "R76RMNFXNAX7",
    "XWPAM6PLA39F",
    "7NLEE677W7WY",
    "9Y7X9JT9E6E9",
    "JHEAW3R7MTMN",
    "ELFWEN7KRTAY",
    "FFHYPLNJJL4E",
    "4LA6XF967LTN",
    "3JYT96NELFPY",
    "P6MNWJXL4FMK",
    "T6F9FW3JLWLL",
    "H6WPLNLHAP67",
    "4XPKMMFE63RL",
    "HRNFHLWNX6EY",
    "96FPNKT9RAPN",
    "WNHMNTN9KMWX",
    "4F3WTYTYR766",
    "XW9RKF6AR7J4",
    "64A9WEMA7MTE",
    "AJAPXTK94KPN",
    "NYJW4R477KXX",
    "YHMWK7P9JKR9",
    "AY673PPAW6HJ",
    "AXRJPPELXMTW",
    "7YAPK4X9HH39",
    "XKHWRNKAT74R",
    "XTRAE3XJ9AYT",
    "MP34EJY7FY34",
    "FXTHTKRFH7AE",
    "W6E9XNNLFRY6",
    "FP7XWTPJ7YMP",
];
